module.exports = __webpack_public_path__ + "res/img_game_bg.70fde6322809a966b7f40e81fbf35d44.png";